export enum ServiceStatusType {
    Ok = 1,
    GroupLimitReached,
}